import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import { ProfilePageSkeleton } from "@/components/ProfilePageSkeleton.tsx";
import {getUserById} from "@/services/userService.ts";
import {User} from "@/types/User.ts";
import {ProfileLeftPanel} from "@/components/ProfileLeftPanel.tsx";

const UserProfile = () => {
    const {id} = useParams(); // Get the user ID from route parameters
    const [user, setUser] = useState<User | null>(null);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                // Fetch user data based on the user ID
                const userData = await getUserById(id ? parseInt(id) : -1);
                setUser(userData);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };

        fetchUserData();
    }, [id]);

    return (
        <>
            {user ? (
                <div className="container pb-12">
                    <div className="md:flex no-wrap md:-mx-2">
                        {/* Left Side */}
                        <ProfileLeftPanel
                            user={user}
                            onProfilePictureUpdated={async () => {
                                const userData = await getUserById(id ? parseInt(id) : -1);
                                setUser(userData);
                            }}
                        />
                        {/* Right Side */}
                        <div className="w-full md:w-9/12 mx-2 h-64"></div>
                    </div>
                </div>
            ) : (
                <ProfilePageSkeleton />
            )}
        </>
    )
}

export default UserProfile;
